package com.parmartechnologies.business.feature.businessConfig.viewModel

import com.parmartechnologies.core.feature.businessConfig.model.BusinessConfig
import com.parmartechnologies.core.feature.businessConfig.network.CreateBusinessConfigRequest
import com.parmartechnologies.core.feature.businessConfig.network.FetchBusinessConfigRequest
import com.parmartechnologies.core.feature.currency.model.Currency
import com.parmartechnologies.core.feature.currency.network.FetchAllCurrencyRequest
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.feature.product.network.BacklistProductRequest
import com.parmartechnologies.core.feature.product.network.RetrieveProductRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.businessConfig.handler.BusinessConfigHandler
import com.parmartechnologies.business.feature.businessConfig.network.BusinessConfigNetwork
import com.parmartechnologies.communication.core.handler.AuthHandler
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class BusinessConfigViewModel : AppViewModel() {

    val repository = BusinessConfigHandler.shared().repository
    val allBusinessConfig: StateFlow<ArrayList<BusinessConfig>>
        get() = repository.allBusinessConfig

    val allCurrency: StateFlow<List<Currency>>
        get() = repository.allCurrency

    val selectedCurrency: StateFlow<Currency>
        get() = repository.selectedCurrency

    val businessConfig: StateFlow<BusinessConfig?>
        get() = repository.businessConfig
//    val editBusinessConfig: StateFlow<BusinessConfig?>
//        get() = repository.editBusinessConfig
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery

    val allProduct: StateFlow<List<Product>>
        get() = repository.allProduct

    fun updateCurrency(value: Currency?) {
        scope.launch {
            repository.updateCurrency(value)
            delay(500)
            updateBusinessConfig {
                if (it) {

                }
            }
        }
    }


    override fun changeSearchQuery(value: String) {
        scope.launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        val searchQueryText = value.lowercase()
        scope.launch {
//            val filteredResult = repository.allUnFilteredBusinessConfig.value.filter { item ->
//                item.currency?.lowercase()
//                    ?.contains(searchQueryText) == true || item.MobileNumberNumber?.lowercase()
//                    ?.contains(searchQueryText) == true || item.EmailID?.lowercase()?.contains(
//                    searchQueryText
//                ) == true || item.Barcode?.contains(value) == true
//            } as ArrayList<BusinessConfig>
//            repository.allBusinessConfigState.emit(filteredResult)
        }
    }

    fun editBusinessConfig(value: BusinessConfig?) {
        repository.setEditBusinessConfig(value)
    }

//    fun editBusinessConfigName(value: String) {
//        repository.editBusinessConfig.value?.Name = value
//    }
//
//    fun editBusinessConfigMobile(value: String) {
//        repository.editBusinessConfig.value?.MobileNumberNumber = value
//    }
//
//    fun editBusinessConfigDialCode(value: String) {
//        repository.editBusinessConfig.value?.DialCode = value
//    }
//
//    fun editBusinessConfigEmail(value: String) {
//        repository.editBusinessConfig.value?.EmailID = value
//    }
//
//    fun editBusinessConfigBarcode(value: String) {
//        repository.editBusinessConfig.value?.Barcode = value
//    }


    fun fetchBusinessConfig() {
        startLoading()
        val request = FetchBusinessConfigRequest(
            BusinessHandler.shared().myBusinessId,
            AuthHandler.shared().UserID,
            ""//repository.LastSyncDate.value
        )
        scope.launch {
            BusinessConfigNetwork().retrieveBusinessConfig(request) {
                stopLoading()
                if (it?.payload?._id?.isNotEmpty() == true) {
                    scope.launch {
                        repository.selectBusinessConfig(it.payload!!)
                        editBusinessConfig(it.payload)
                    }
                    fetchAllCurrency()
                } else {
//                    AlertHandler.shared().showAlert("no bysiness config", "")
                }
            }
        }
    }

    fun fetchAllCurrency() {
        startLoading()
        val request = FetchAllCurrencyRequest(
            BusinessHandler.shared().repository.myBusiness.value._id,
            AuthHandler.shared().UserID,
            ""
        )
        scope.launch {
            BusinessConfigNetwork().retrieveAllCurrency(request) {
                stopLoading()
                if (it?.payload?.isNotEmpty() == true) {
                    scope.launch {
                        repository.allCurrencyState.emit(it.payload)
                        it.payload.forEach { currency ->
                            if (!businessConfig.value?.currency?.symbol.isNullOrEmpty()) {
                                if (currency.symbol == businessConfig.value!!.currency?.symbol) {
                                    repository.selectedCurrencyState.emit(currency)
                                }
                            } else {
//                                if (currency.code == AppConfig.shared().countryCode) {
//                                    repository.selectedCurrencyState.emit(currency)
//                                }
                            }

                        }
                    }
                } else {
//                    AlertHandler.shared().showAlert("hi", "it ${it}")
                }
            }
        }
    }

    fun createNewBusinessConfig(
        name: String,
        dialCode: String,
        mobile: String,
        email: String,
        Barcode: String,
        callBack: (Boolean) -> Unit
    ) {
        val request = CreateBusinessConfigRequest(
            AuthHandler.shared().UserID,
            BusinessHandler.shared().repository.myBusiness.value._id,
            name,
            dialCode,
            mobile,
            email,
            Barcode,
            AuthHandler.shared().deviceId
        )
        startLoading()
        scope.launch {
//            BusinessConfigNetwork().createBusinessConfig(request) {
//                stopLoading()
//                if (!it?.payload?._id.isNullOrEmpty()) {
//                    callBack(true)
//                    scope.launch {
//                        BusinessConfigHandler.shared().repository.businessConfigState.emit(it!!.payload!!)
//                    }
//                } else {
//                    callBack(false)
//                }
//            }
        }
    }

    private fun updateBusinessConfig(
        callBack: (Boolean) -> Unit
    ) {
//        if (repository.editBusinessConfig.value?._id?.isNotEmpty() == true) {
//            val request =
//                UpdateBusinessConfigRequest(
//                    repository.editBusinessConfig.value!!._id,
//                    AuthHandler.shared().UserID,
//                    BusinessHandler.shared().repository.business.value._id,
//                    currency = repository.editBusinessConfig.value?.currency
//                )
//            startLoading()
//            scope.launch {
//                BusinessConfigNetwork().updateBusinessConfig(request) { response ->
//                    stopLoading()
//                    if (!response?.payload?._id.isNullOrEmpty()) {
//                        callBack(true)
//                        scope.launch {
//                            BusinessConfigHandler.shared().repository.businessConfigState.emit(
//                                response?.payload ?: BusinessConfig()
//                            )
//                        }
//                        AlertHandler.shared().showAlert("Success", "Updated successfully")
//                    } else {
//                        callBack(false)
////                        AlertHandler.shared()
////                            .showAlert(
////                                "Oops!",
////                                "Something went wrong, please try after some time"
////                            )
//                    }
//                }
//            }
//        } else {
//            AlertHandler.shared().showAlert("Oops!", "No Business Config")
//        }

    }

    fun fetchAllProduct() {
        startLoading()
        val request = RetrieveProductRequest(
            BusinessHandler.shared().myBusinessId,
            ""
        )
        scope.launch {
            BusinessConfigNetwork().retrieveAllProduct(request) {
                stopLoading()
                if (it?.payload?.isNotEmpty() == true) {
                    scope.launch {
                        repository.allProductState.emit(it.payload)
                    }
                } else {
//                    AlertHandler.shared().showAlert("hi", "it ${it}")
                }
            }
        }
    }

    fun blacklistProduct(product: Product, callBack: (Boolean) -> Unit) {
        val request = BacklistProductRequest(
            _id = product._id,
            isBlacklisted = product.IsBlacklisted
        )
        startLoading()
        scope.launch {
//            ProductNetwork().blacklist(request) {
//                stopLoading()
//                if (it?.status?.equals("SUCCESS") == true) {
//                    callBack(true)
//                } else {
//                    callBack(false)
//                }
//            }
        }
    }

}